import { createInstance } from '@adobe/alloy';
import webEvent from './web-event.json';
import api from '../../../api';
import { alloyConfig } from '../../config';
import * as Bowser from 'bowser';

const alloy = createInstance({ name: 'alloy' });
const config = alloyConfig();

// SQL Query example: select * from onsemi_web_data_set_3 owds WHERE _onsemi.activityInfo.activityTealiumEvent = 'wdt_download_datasheet'

alloy('configure', {
	edgeConfigId: config.edgeConfigId,
	orgId: config.orgId,
	debugEnabled: config.debugEnabled
});

export const logEventType = { PRODUCTLOG: 'ProductLog', DATASHEETLOG: 'DatasheetLog' };

const browser = Bowser.getParser(window.navigator.userAgent);

const toolName = 'Product RecommendationTools+';
export let segment = '';
export let breadcrumbs = '';

export const adobPageView = category => {
	let currentURL = window.location.href;
	segment = category;
	let we = structuredClone(webEvent);
	we._onsemi.activityInfo.activityLink = currentURL;
	we._onsemi.webInfo.mainUrl = currentURL.substring(0, currentURL.indexOf('plus/') + 5);
	we._onsemi.activityInfo.activityAssetTitle = toolName + 'Find Product-' + category;
	we._onsemi.activityInfo.activityProductName = toolName + 'Find the Optimum Product for your Application';
	we._onsemi.activityInfo.activityType = 'Product RecommendationTools';
	we._onsemi.activityInfo.activityTealiumEvent = 'prt_find_products';
	we._onsemi.activityInfo.activityBreadScrumb = breadcrumbs;
	we._onsemi.webInfo.prtProductsSegment = segment;
	we._onsemi.activityInfo.activityDescription = breadcrumbs + ' -' + we._onsemi.activityInfo.activityAssetTitle;
	sendEvent(we);
};

export const adobProductLog = async trackingParameters => {
	let we = structuredClone(webEvent);
	we._onsemi.activityInfo.activityLink = trackingParameters.redirectLink;
	we._onsemi.activityInfo.activityAssetTitle = toolName + 'WPN-' + trackingParameters.partNumber;
	we._onsemi.activityInfo.activityProductName = trackingParameters.segment + ' - ' + toolName;
	we._onsemi.activityInfo.activityType = 'Product RecommendationTools';
	we._onsemi.activityInfo.activityTealiumEvent = 'prt_view_wpn';
	we._onsemi.activityInfo.activityBreadScrumb = trackingParameters.breadcrumbs;
	we._onsemi.webInfo.prtProductsSegment = trackingParameters.segment;
	we._onsemi.activityInfo.activityDescription =
		trackingParameters.breadcrumbs + ' -' + we._onsemi.activityInfo.activityAssetTitle;
	we._onsemi.webInfo.buttonName = trackingParameters.partNumber;
	we._onsemi.webInfo.buttonType = 'Open';
	we._onsemi.webInfo.buttonHref = trackingParameters.redirectLink;
	we._onsemi.webInfo.fullUrl = trackingParameters.fullURL;
	we._onsemi.webInfo.urlPath = trackingParameters.path;
	return sendEvent(we);
};

export const adobDatasheetLog = async trackingParameters => {
	let we = structuredClone(webEvent);
	we._onsemi.activityInfo.activityLink = trackingParameters.redirectLink;
	we._onsemi.activityInfo.activityAssetTitle = toolName + 'Datasheet-' + trackingParameters.partNumber;
	we._onsemi.activityInfo.activityProductName = trackingParameters.segment + ' - ' + toolName;
	we._onsemi.activityInfo.activityType = 'Datasheet';
	we._onsemi.activityInfo.activityTealiumEvent = 'prt_download_datasheet';
	we._onsemi.activityInfo.activityBreadScrumb = trackingParameters.breadcrumbs;
	we._onsemi.webInfo.prtProductsSegment = trackingParameters.segment;
	we._onsemi.webInfo.prtDatashetName = trackingParameters.partNumber;
	we._onsemi.activityInfo.activityDescription =
		trackingParameters.breadcrumbs + ' -' + we._onsemi.activityInfo.activityAssetTitle;
	we._onsemi.webInfo.buttonName = trackingParameters.buttonName;
	we._onsemi.webInfo.buttonType = 'Open';
	we._onsemi.webInfo.buttonHref = trackingParameters.redirectLink;
	we._onsemi.webInfo.fullUrl = trackingParameters.fullURL;
	we._onsemi.webInfo.urlPath = trackingParameters.path;
	return sendEvent(we);
};

export const adobLegacyToolsRedirect = link => {
	let we = structuredClone(webEvent);
	we._onsemi.activityInfo.activityLink = link;
	we._onsemi.activityInfo.activityAssetTitle = 'Product RecommendationTools-PRT';
	we._onsemi.activityInfo.activityProductName = 'Product Recommendation Tool';
	we._onsemi.activityInfo.activityType = 'Product RecommendationTools';
	we._onsemi.activityInfo.activityTealiumEvent = 'prt';
	we._onsemi.webInfo.buttonName = 'FIND PRODUCTS';
	we._onsemi.webInfo.buttonType = 'Open';
	we._onsemi.webInfo.buttonHref = link;
	sendEvent(we);
};

const sendEvent = async we => {
	return alloy('getIdentity')
		.then(identity => {
			const mainIdentityKey = buildIdentityObj(identity.identity.ECID, true);
			we.identityMap.ECID = [];
			we.identityMap.ECID.push(mainIdentityKey);
		})
		.then(async () => {
			await api.getUserInfo().then(data => {
				if (data.email) {
					we._onsemi.myon.firstName = data.firstName;
					we._onsemi.myon.lastName = data.lastName;
					we._onsemi.myon.email = data.email;
					we.personalEmail = {
						address: data.email
					};
					we.person = {
						firstName: data.firstName,
						lastName: data.lastName
					};
					we.identityMap.Email = [];
					const emailIdentityKey = buildIdentityObj(data.email, false);
					we.identityMap.Email.push(emailIdentityKey);
				}
			});
		})
		.then(() => {
			try {
				const fullURL = we._onsemi.webInfo.fullUrl ? we._onsemi.webInfo.fullUrl : window.location.href;
				const path = we._onsemi.webInfo.urlPath ? we._onsemi.webInfo.urlPath : window.location.pathname;
				we.web.webReferrer.type = getReferrerType();
				setMiscFields(we, fullURL);
				setUtmFields(we, fullURL);
				setLinkPath(we, fullURL, path);
			} catch (e) {
				console.log(e);
			}
			return alloy('sendEvent', {
				xdm: we
			});
		});
};

const buildIdentityObj = (id, primary) => {
	return {
		id: id,
		primary: primary
	};
};

const setMiscFields = (we, fullURL) => {
	const date = new Date();
	we._onsemi.activityInfo.activityTime = date.toISOString();
	const url = new URL(fullURL);
	we._onsemi.activityInfo.activitySource = url.hostname;
	we.environment.browserDetails.acceptLanguage = navigator.language || navigator.userLanguage;
	we.environment.browserDetails.cookiesEnabled = navigator.cookieEnabled;
	we.environment.browserDetails.name = browser.getBrowserName();
	we.placeContext.geo._schema.latitude = -88.888;
	we.placeContext.geo._schema.longitude = -88.888;
	setSessionId(we, date);
};

const setSessionId = (we, date) => {
	we._onsemi.webInfo.sessionId = 1;
	try {
		if (window && window._satellite) {
			const visNum = String(window._satellite.getVar('visitNum'));
			if (visNum) {
				we._onsemi.webInfo.sessionId = Number(visNum);
			}
		}
	} catch (e) {
		console.log(e);
	}
};

const setUtmFields = (we, fullUrl) => {
	const url = new URL(fullUrl);
	if (url.searchParams.get('utm_source')) {
		we._onsemi.webInfo.queryString = fullUrl.split('?', 2)[1];
		we._onsemi.utmInfo.utmSource = url.searchParams.get('utm_source');
	}
	if (url.searchParams.get('utm_medium')) {
		we._onsemi.utmInfo.utmMedium = url.searchParams.get('utm_medium');
	}
	if (url.searchParams.get('utm_content')) {
		we._onsemi.utmInfo.utmContent = url.searchParams.get('utm_content');
	}
	if (url.searchParams.get('utm_region')) {
		we._onsemi.utmInfo.utmRegion = url.searchParams.get('utm_region');
	}
	if (url.searchParams.get('utm_campaign')) {
		we._onsemi.utmInfo.utmCampaign = url.searchParams.get('utm_campaign');
	}
	if (url.searchParams.get('utm_term')) {
		we._onsemi.utmInfo.utmTerm = url.searchParams.get('utm_term');
	}
};

const getReferrerType = () => {
	if (window.location.search.includes('utm')) {
		return 'external';
	} else if (
		document.referrer.includes(
			'google.' || 'bing.' || 'baidu.' || 'www.so.com' || 'yandex.' || 'sogou.' || 'rakuten.' || 'yahoo.'
		)
	) {
		return 'search_engine';
	} else if (
		document.referrer.includes(
			'facebook' ||
				'fb' ||
				'instagram' ||
				'linkedin' ||
				'youtube' ||
				'reddit' ||
				'wechat' ||
				'whatsapp' ||
				'twitter' ||
				'vk.com' ||
				'zhihu'
		)
	) {
		return 'social';
	} else if (document.referrer.includes('.onsemi.')) {
		return 'internal';
	} else if (document.referrer.length > 1) {
		return 'typed_bookmarked';
	} else {
		return 'unknown';
	}
};

const setLinkPath = (we, fullUrl, path) => {
	we._onsemi.webInfo.fullUrl = fullUrl;
	we._onsemi.webInfo.mainUrl = we._onsemi.webInfo.mainUrl ? we._onsemi.webInfo.mainUrl : fullUrl.split('?')[0];
	we._onsemi.webInfo.urlPath = path;
	const ps = path.split('/');
	for (let i = 1; i < ps.length && i <= 6; i++) {
		if (ps[i]) {
			we._onsemi.webInfo['urlPath' + i] = ps[i];
		}
	}
};

export const setBreadcrumbForAdob = response => {
	breadcrumbs = response[0].label;
};
